import { Grid, Typography } from "@mui/material";
import { ReactNode } from "react";

interface FirefliesSummaryProps {
  initialSummary: string;

  extraAction?: ReactNode;
}

const FirefliesSummary = ({
  initialSummary,
  extraAction,
}: FirefliesSummaryProps) => {
  return (
    <Grid container gap={1} width={"100%"}>
      <Grid item xs={12}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Typography
              color="#1E293A"
              fontSize={"18px"}
              lineHeight={"18px"}
              fontWeight={600}
              gutterBottom
            >
              Meeting Summary
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            {extraAction && (
              <span style={{ marginLeft: 8 }}>{extraAction}</span>
            )}
          </Grid>
        </Grid>
      </Grid>
      <Grid xs={12} item>
        <Typography
          sx={{ whiteSpace: "pre-line" }}
          color="#667086"
          fontSize={"14px"}
          lineHeight={"22px"}
        >
          {initialSummary}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default FirefliesSummary;
